import React from 'react';
import Environment from '@di-shared/features/environment/Environment';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {BrandType, ThemeType} from '@shared/cci/features/const/environment';
import EuKiaLight from '@di-shared/features/about/HabitImageSvg/.eu.kia.light';
import EuKiaDark from '@di-shared/features/about/HabitImageSvg/.eu.kia.dark';
import EuHyundaiLight from '@di-shared/features/about/HabitImageSvg/.eu.hyundai.light';
import EuHyundaiDark from '@di-shared/features/about/HabitImageSvg/.eu.hyundai.dark';
import EuGenesisLight from '@di-shared/features/about/HabitImageSvg/.eu.genesis.light';
import EuGenesisDark from '@di-shared/features/about/HabitImageSvg/.eu.genesis.dark';

function HabitImageSvg(): JSX.Element {
  const theme = useEnvironmentStore((state) => state.theme);
  const brand = import.meta.env.VITE_BRAND;
  return (
    <Environment.Eu>
      {brand === BrandType.KIA && (theme === ThemeType.LIGHT ? <EuKiaLight /> : <EuKiaDark />)}
      {brand === BrandType.HYUNDAI && (theme === ThemeType.LIGHT ? <EuHyundaiLight /> : <EuHyundaiDark />)}
      {brand === BrandType.GENESIS && (theme === ThemeType.LIGHT ? <EuGenesisLight /> : <EuGenesisDark />)}
    </Environment.Eu>
  );
}

export default HabitImageSvg;
